import React, { useEffect, useState } from 'react';
import { Form, Tabs, Row, Col, Select, Input, DatePicker, Checkbox, Divider, Radio, Button, message, Spin, Upload, Card, TreeSelect, Space, Tag, Cascader } from 'antd';
import { UploadOutlined, DownloadOutlined, PlusOutlined, DeleteOutlined, CheckCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { GetCursos } from '../../../dao/metadata/ManageCursos';
import { GetAlumneId } from '../../../dao/GetAlumneId';
import { PutUsuari } from '../../../dao/PutUsuari';

interface Props {
    idUsuari: number;
    onSuccess?: () => void;
}

const levels = ['-','A1', 'A2', 'B1', 'B2', 'C1', 'C2'];
const estudisOptions = ['Batxillerat', 'GM', 'GS', 'Universitat', 'ESO', 'SOC', 'Altres'];

// Municipis de la província de Barcelona (selecció àmplia)
const treeDataPoblacions = [
    { title: 'Barcelona (ciutat)', value: 'Barcelona' },
    // Baix Llobregat
    { title: "L'Hospitalet de Llobregat", value: "L'Hospitalet de Llobregat" },
    { title: 'Cornellà de Llobregat', value: 'Cornellà de Llobregat' },
    { title: 'Sant Boi de Llobregat', value: 'Sant Boi de Llobregat' },
    { title: 'Viladecans', value: 'Viladecans' },
    { title: 'Gavà', value: 'Gavà' },
    { title: 'Castelldefels', value: 'Castelldefels' },
    { title: 'El Prat de Llobregat', value: 'El Prat de Llobregat' },
    { title: 'Esplugues de Llobregat', value: 'Esplugues de Llobregat' },
    { title: 'Sant Joan Despí', value: 'Sant Joan Despí' },
    { title: 'Sant Just Desvern', value: 'Sant Just Desvern' },
    { title: 'Santa Coloma de Cervelló', value: 'Santa Coloma de Cervelló' },
    { title: 'Sant Vicenç dels Horts', value: 'Sant Vicenç dels Horts' },
    { title: 'Pallejà', value: 'Pallejà' },
    { title: 'Molins de Rei', value: 'Molins de Rei' },
    { title: 'Sant Feliu de Llobregat', value: 'Sant Feliu de Llobregat' },
    { title: "Sant Andreu de la Barca", value: "Sant Andreu de la Barca" },
    { title: 'Martorell', value: 'Martorell' },
    { title: 'Abrera', value: 'Abrera' },
    { title: 'Olesa de Montserrat', value: 'Olesa de Montserrat' },
    { title: 'Esparreguera', value: 'Esparreguera' },
    { title: 'Begues', value: 'Begues' },
    { title: 'Cervelló', value: 'Cervelló' },
    // Vallès Occidental
    { title: 'Terrassa', value: 'Terrassa' },
    { title: 'Sabadell', value: 'Sabadell' },
    { title: 'Sant Cugat del Vallès', value: 'Sant Cugat del Vallès' },
    { title: 'Rubí', value: 'Rubí' },
    { title: 'Cerdanyola del Vallès', value: 'Cerdanyola del Vallès' },
    { title: 'Barberà del Vallès', value: 'Barberà del Vallès' },
    { title: 'Ripollet', value: 'Ripollet' },
    { title: 'Montcada i Reixac', value: 'Montcada i Reixac' },
    { title: 'Badia del Vallès', value: 'Badia del Vallès' },
    { title: 'Castellbisbal', value: 'Castellbisbal' },
    { title: 'El Papiol', value: 'El Papiol' },
    { title: 'Polinyà', value: 'Polinyà' },
    { title: 'Sentmenat', value: 'Sentmenat' },
    { title: 'Ullastrell', value: 'Ullastrell' },
    { title: 'Viladecavalls', value: 'Viladecavalls' },
    // Vallès Oriental
    { title: 'Granollers', value: 'Granollers' },
    { title: 'Mollet del Vallès', value: 'Mollet del Vallès' },
    { title: 'Parets del Vallès', value: 'Parets del Vallès' },
    { title: 'Caldes de Montbui', value: 'Caldes de Montbui' },
    { title: 'La Garriga', value: 'La Garriga' },
    { title: 'Les Franqueses del Vallès', value: 'Les Franqueses del Vallès' },
    { title: 'Cardedeu', value: 'Cardedeu' },
    { title: 'Llinars del Vallès', value: 'Llinars del Vallès' },
    { title: 'Martorelles', value: 'Martorelles' },
    { title: 'Sant Celoni', value: 'Sant Celoni' },
    // Barcelonès
    { title: 'Badalona', value: 'Badalona' },
    { title: 'Santa Coloma de Gramenet', value: 'Santa Coloma de Gramenet' },
    { title: 'Sant Adrià de Besòs', value: 'Sant Adrià de Besòs' },
    { title: 'Montgat', value: 'Montgat' },
    // Maresme
    { title: 'Mataró', value: 'Mataró' },
    { title: 'Premià de Mar', value: 'Premià de Mar' },
    { title: 'Premià de Dalt', value: 'Premià de Dalt' },
    { title: 'Vilassar de Mar', value: 'Vilassar de Mar' },
    { title: 'Vilassar de Dalt', value: 'Vilassar de Dalt' },
    { title: 'El Masnou', value: 'El Masnou' },
    { title: 'Alella', value: 'Alella' },
    { title: 'Teià', value: 'Teià' },
    { title: 'Tiana', value: 'Tiana' },
    { title: 'Badalona (Maresme)', value: 'Badalona' },
    { title: 'Calella', value: 'Calella' },
    { title: 'Pineda de Mar', value: 'Pineda de Mar' },
    { title: 'Malgrat de Mar', value: 'Malgrat de Mar' },
    { title: 'Sant Pol de Mar', value: 'Sant Pol de Mar' },
    { title: 'Arenys de Mar', value: 'Arenys de Mar' },
    { title: 'Canet de Mar', value: 'Canet de Mar' },
    // Berguedà / Bages / Anoia
    { title: 'Manresa', value: 'Manresa' },
    { title: 'Igualada', value: 'Igualada' },
    { title: 'Berga', value: 'Berga' },
    { title: 'Navàs', value: 'Navàs' },
    // Osona
    { title: 'Vic', value: 'Vic' },
    { title: 'Manlleu', value: 'Manlleu' },
    { title: 'Torelló', value: 'Torelló' },
    // Garraf
    { title: 'Vilanova i la Geltrú', value: 'Vilanova i la Geltrú' },
    { title: 'Sitges', value: 'Sitges' },
    { title: 'Sant Pere de Ribes', value: 'Sant Pere de Ribes' },
    { title: 'Cubelles', value: 'Cubelles' },
    { title: 'Canyelles', value: 'Canyelles' },
    // Alt Penedès
    { title: 'Vilafranca del Penedès', value: 'Vilafranca del Penedès' },
    { title: 'Sant Sadurní d\'Anoia', value: "Sant Sadurní d'Anoia" },
    { title: 'Gelida', value: 'Gelida' },
];


const DualProfileForm: React.FC<Props> = ({ idUsuari, onSuccess }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [uploading, setUploading] = useState<string | null>(null);
    const [cursos, setCursos] = useState<any[]>([]);
    const [cascaderCursos, setCascaderCursos] = useState<any[]>([]);
    const [showExempcio, setShowExempcio] = useState(false);
    const [extraIdiomes, setExtraIdiomes] = useState<{nom: string, nivell: string}[]>([]);
    const [docStatus, setDocStatus] = useState({ has_cv: false, has_nuss: false });

    const buildCascaderOptions = (flatList: any[]) => {
        const roots: any[] = [];
        const map: any = {};
        flatList.forEach(item => {
            map[item.id] = { value: item.value, label: item.label, children: [] };
        });
        flatList.forEach(item => {
            if (item.parent_id && map[item.parent_id]) {
                map[item.parent_id].children.push(map[item.id]);
            } else if (!item.parent_id) {
                roots.push(map[item.id]);
            }
        });
        const cleanChildren = (nodes: any[]) => {
            nodes.forEach(node => {
                if (node.children.length === 0) delete node.children;
                else cleanChildren(node.children);
            });
        };
        cleanChildren(roots);
        return roots;
    };

    useEffect(() => {
        const loadInitial = async () => {
            setLoading(true);
            try {
                const cData = await GetCursos();
                setCursos(cData);
                setCascaderCursos(buildCascaderOptions(cData));
                if (idUsuari) await fetchData();
            } catch(e) {}
            setLoading(false);
        };
        loadInitial();
    }, [idUsuari]);

    const fetchData = async () => {
        try {
            const baseUrl = (process.env.REACT_APP_API_URL || 'http://localhost').replace(/\/$/, "");
            
            // Fetch metadata detall (dual)
            const metaRes = await fetch(`${baseUrl}:8061/metadata/alumnes/me?userId=${idUsuari}`, {
                headers: { 'Authorization': `Bearer ${localStorage.getItem('authToken')}` }
            });
            const metaData = await metaRes.json();

            // Fetch info bàsica (doctorat.usuari)
            const aluDataRaw = await GetAlumneId(idUsuari.toString());
            const usuData = aluDataRaw?.alumne;

            if (metaData || usuData) {
                setDocStatus({ 
                    has_cv: !!(metaData?.has_cv || metaData?.cv_path), 
                    has_nuss: !!(metaData?.has_nuss || metaData?.nuss_path) 
                });

                form.setFieldsValue({
                    ...metaData,
                    ...usuData,
                    curs_grup_cascader: usuData?.grup && usuData?.curs ? [usuData.grup, usuData.curs] : undefined,
                    data_naixement: metaData?.data_naixement ? dayjs(metaData.data_naixement) : null,
                    curs_primera_matricula: metaData?.curs_primera_matricula ? dayjs(metaData.curs_primera_matricula, 'YYYY') : null,
                    nacionalitat_espanyola: metaData?.nacionalitat_espanyola === 1,
                    es_repetidor: metaData?.es_repetidor === 1,
                    experiencia_laboral: metaData?.experiencia_laboral === 1,
                    treballant_actualment: metaData?.treballant_actualment === 1,
                    disponibilitat_estiu: metaData?.disponibilitat_estiu === 1,
                    sol_licitar_exempcio: metaData?.sol_licitar_exempcio === 1
                });
                setShowExempcio(metaData?.sol_licitar_exempcio === 1);
                if (metaData?.idioma_altres && metaData?.idioma_altres !== 'null') {
                    try { setExtraIdiomes(JSON.parse(metaData.idioma_altres)); } catch(e) {}
                }
            }
        } catch (e) {
            console.error("Error fetching dual data:", e);
        }
    };

    const handleSave = async (values: any) => {
        try {
            const baseUrl = (process.env.REACT_APP_API_URL || 'http://localhost').replace(/\/$/, "");
            
            // 1. Actualitzar dades de metadades (DUAL)
            const metaPayload = {
                ...values,
                id_usuari: idUsuari,
                grup_actual: values.curs_grup_cascader?.[1], // Guardem el curs com grup_actual a meta
                data_naixement: values.data_naixement ? values.data_naixement.format('YYYY-MM-DD') : null,
                curs_primera_matricula: values.curs_primera_matricula ? values.curs_primera_matricula.format('YYYY') : null,
                nacionalitat_espanyola: values.nacionalitat_espanyola ? 1 : 0,
                es_repetidor: values.es_repetidor ? 1 : 0,
                experiencia_laboral: values.experiencia_laboral ? 1 : 0,
                treballant_actualment: values.treballant_actualment ? 1 : 0,
                disponibilitat_estiu: values.disponibilitat_estiu ? 1 : 0,
                sol_licitar_exempcio: values.sol_licitar_exempcio ? 1 : 0,
                idioma_altres: JSON.stringify(extraIdiomes)
            };
            
            const metaRes = await fetch(`${baseUrl}:8061/metadata/alumnes/detall`, {
                method: 'PUT',
                headers: { 'Authorization': `Bearer ${localStorage.getItem('authToken')}`, 'Content-Type': 'application/json' },
                body: JSON.stringify(metaPayload)
            });

            // 2. Actualitzar curs/grup/dades personals a doctorat.usuari
            const userPayload = {
                id: idUsuari,
                nom: values.nom,
                cognoms: values.cognoms,
                email: values.email,
                curs: values.curs_grup_cascader?.[1] || '',
                grup: values.curs_grup_cascader?.[0] || '',
            };

            await PutUsuari(userPayload);

            if (metaRes.ok) {
                message.success('Dades actualitzades correctament (Dual i Usuari)');
                if (onSuccess) onSuccess();
            } else {
                message.error('Error al actualitzar dades de Dual');
            }
        } catch (e) {
            console.error("Error saving data:", e);
            message.error('Error de connexió al guardar');
        }
    };

    const handleFileUpload = async (type: 'CV' | 'NUSS', file: File) => {
        setUploading(type);
        const formData = new FormData();
        formData.append('file', file);
        try {
            const baseUrl = (process.env.REACT_APP_API_URL || 'http://localhost').replace(/\/$/, "");
            const response = await fetch(`${baseUrl}:8061/metadata/alumnes/${idUsuari}/documents/${type}`, {
                method: 'POST',
                headers: { 'Authorization': `Bearer ${localStorage.getItem('authToken')}` },
                body: formData
            });
            if (response.ok) {
                message.success('Document pujat correctament');
                fetchData(); // Recarregar per veure el check
            }
        } catch (e) {}
        setUploading(null);
        return false;
    };

    const handleDownload = async (type: 'CV' | 'NUSS') => {
        try {
            const baseUrl = (process.env.REACT_APP_API_URL || 'http://localhost').replace(/\/$/, "");
            const res = await fetch(`${baseUrl}:8061/metadata/alumnes/${idUsuari}/documents/${type}/download`, {
                headers: { 'Authorization': `Bearer ${localStorage.getItem('authToken')}` }
            });
            if (!res.ok) {
                message.error('El document no existeix o no es pot descarregar.');
                return;
            }
            
            const contentDisposition = res.headers.get('Content-Disposition');
            let filename = `${type}_${idUsuari}.pdf`;
            if (contentDisposition && contentDisposition.includes('filename=')) {
                filename = contentDisposition.split('filename=')[1].replace(/['"]/g, '');
            }

            const blob = await res.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
        } catch (e) {
            message.error('Error descarregant document');
            console.error(e);
        }
    };

    const handleRemoveIdioma = (index: number) => {
        const newLangs = [...extraIdiomes];
        newLangs.splice(index, 1);
        setExtraIdiomes(newLangs);
    };

    if (loading) return <div style={{textAlign:'center', padding:50}}><Spin size="large" /></div>;

    return (
        <Form form={form} layout="vertical" onFinish={handleSave}>
            <Tabs defaultActiveKey="1">
                <Tabs.TabPane tab="Personal" key="1">
                    <Row gutter={16}>
                        <Col span={8}><Form.Item name="nom" label="Nom"><Input /></Form.Item></Col>
                        <Col span={8}><Form.Item name="cognoms" label="Cognoms"><Input /></Form.Item></Col>
                        <Col span={8}><Form.Item name="email" label="Correu Electrònic"><Input /></Form.Item></Col>
                    </Row>
                    <Row gutter={16}>
                        <Col span={8}><Form.Item name="document_identificacio" label="DNI/NIE/Pass"><Select options={[{value:'DNI',label:'DNI'},{value:'NIE',label:'NIE'},{value:'Passaport',label:'Passaport'}]}/></Form.Item></Col>
                        <Col span={8}><Form.Item name="numero_document" label="Núm. Document"><Input /></Form.Item></Col>
                        <Col span={8}><Form.Item name="data_naixement" label="Naixement"><DatePicker style={{width:'100%'}}/></Form.Item></Col>
                    </Row>
                    <Row gutter={16}>
                        <Col span={8}><Form.Item name="nass" label="NASS"><Input /></Form.Item></Col>
                        <Col span={8}><Form.Item name="tsi_mutua" label="TSI/Mútua"><Input /></Form.Item></Col>
                        <Col span={8}><Form.Item name="nacionalitat_espanyola" valuePropName="checked"><Checkbox>Nacionalitat Espanyola</Checkbox></Form.Item></Col>
                    </Row>
                    <Row gutter={16}>
                        <Col span={10}><Form.Item name="adreca" label="Adreça"><Input /></Form.Item></Col>
                        <Col span={7}><Form.Item name="municipi" label="Municipi"><Input /></Form.Item></Col>
                        <Col span={7}><Form.Item name="codi_postal" label="CP"><Input /></Form.Item></Col>
                    </Row>
                </Tabs.TabPane>
                <Tabs.TabPane tab="Acadèmic" key="3">
                    <Row gutter={12}>
                        <Col span={8}><Form.Item name="curs_primera_matricula" label="Curs 1a Matrícula (Any)"><DatePicker picker="year" style={{width:'100%'}}/></Form.Item></Col>
                        <Col span={10}><Form.Item name="curs_grup_cascader" label="Grup / Curs">
                            <Cascader options={cascaderCursos} placeholder="Selecciona cicle i curs" expandTrigger="hover" />
                        </Form.Item></Col>
                        <Col span={6}><Form.Item name="estudis_procedencia" label="Procedeix de">
                            <Select options={estudisOptions.map(o=>({label:o,value:o}))}/>
                        </Form.Item></Col>
                    </Row>
                    <Form.Item name="es_repetidor" valuePropName="checked"><Checkbox>Ets repetidor?</Checkbox></Form.Item>
                </Tabs.TabPane>
                <Tabs.TabPane tab="Laboral / Pref." key="4">
                    <Divider orientation="left">Preferències Població (Arbre Catalunya)</Divider>
                    <Row gutter={8}>
                        {[1,2,3,4].map(idx => (
                            <Col span={6} key={idx}>
                                <Form.Item name={`poblacio_pref_${idx}`} label={`${idx}a Opció`}>
                                    <TreeSelect treeData={treeDataPoblacions} showSearch placeholder="Població" popupMatchSelectWidth={false} />
                                </Form.Item>
                            </Col>
                        ))}
                    </Row>
                    <Divider />
                    <Form.Item name="sol_licitar_exempcio" valuePropName="checked">
                        <Checkbox onChange={(e) => setShowExempcio(e.target.checked)}>Vull sol·licitar Exempció de pràctiques</Checkbox>
                    </Form.Item>
                    {showExempcio && (
                        <Card size="small" style={{marginTop: 10, background: '#f0f2f5'}}>
                            <Form.Item name="tipus_exempcio" label="Modalitat d'Exempció">
                                <Radio.Group>
                                    <Radio value="TOTAL">
                                        <b>TOTAL</b>: Experiència professional en el mateix camp. Hores = mòdul.
                                    </Radio><br/>
                                    <Radio value="PARCIAL_50">
                                        <b>PARCIAL 50%</b>: Mateix camp professional. Hores = 50% mòdul.
                                    </Radio><br/>
                                    <Radio value="PARCIAL_25">
                                        <b>PARCIAL 25%</b>: Qualsevol activitat. Hores = Doble hores mòdul o més.
                                    </Radio>
                                </Radio.Group>
                            </Form.Item>
                        </Card>
                    )}
                </Tabs.TabPane>
                <Tabs.TabPane tab="Idiomes" key="5">
                    <Row gutter={12}>
                        <Col span={8}><Form.Item name="idioma_catala" label="Català"><Select options={levels.map(l=>({label:l,value:l}))}/></Form.Item></Col>
                        <Col span={8}><Form.Item name="idioma_castella" label="Castellà"><Select options={levels.map(l=>({label:l,value:l}))}/></Form.Item></Col>
                        <Col span={8}><Form.Item name="idioma_angles" label="Anglès"><Select options={levels.map(l=>({label:l,value:l}))}/></Form.Item></Col>
                    </Row>
                    <Divider orientation="left">Idiomes Addicionals</Divider>
                    {extraIdiomes.map((item, index) => (
                        <Row gutter={8} key={index} style={{marginBottom: 8}}>
                            <Col span={10}><Input placeholder="Nom idioma..." value={item.nom} onChange={e => {
                                const l = [...extraIdiomes]; l[index].nom = e.target.value; setExtraIdiomes(l);
                            }}/></Col>
                            <Col span={10}><Select style={{width:'100%'}} value={item.nivell} options={levels.map(l=>({label:l,value:l}))} onChange={v => {
                                const l = [...extraIdiomes]; l[index].nivell = v; setExtraIdiomes(l);
                            }}/></Col>
                            <Col span={4}><Button danger icon={<DeleteOutlined />} onClick={() => handleRemoveIdioma(index)} /></Col>
                        </Row>
                    ))}
                    <Button type="dashed" icon={<PlusOutlined />} onClick={() => setExtraIdiomes([...extraIdiomes, {nom:'', nivell:'A1'}])} block>Afegir Idioma</Button>
                </Tabs.TabPane>
                <Tabs.TabPane tab="Documents" key="6">
                    <Row gutter={24}>
                        <Col span={12}>
                            <Card 
                                title={<Space><span>Currículum Vitae</span> {docStatus.has_cv ? <Tag color="success" icon={<CheckCircleOutlined />}>Carregat</Tag> : <Tag color="warning" icon={<ExclamationCircleOutlined />}>Pendent</Tag>}</Space>} 
                                size="small"
                                headStyle={{ background: docStatus.has_cv ? '#f6ffed' : '#fffbe6' }}
                            >
                                <Space direction="vertical" style={{ width: '100%' }}>
                                    <Upload beforeUpload={(f)=>handleFileUpload('CV',f)} showUploadList={false}>
                                        <Button icon={<UploadOutlined />} loading={uploading==='CV'} block>Pujar / Actualitzar CV</Button>
                                    </Upload>
                                    <Button 
                                        type="primary"
                                        icon={<DownloadOutlined />} 
                                        onClick={()=>handleDownload('CV')} 
                                        disabled={!docStatus.has_cv}
                                        style={{ backgroundColor: docStatus.has_cv ? '#52c41a' : undefined, borderColor: docStatus.has_cv ? '#52c41a' : undefined }}
                                        block
                                    >
                                        Baixar CV
                                    </Button>
                                </Space>
                            </Card>
                        </Col>
                        <Col span={12}>
                            <Card 
                                title={<Space><span>Certificat NUSS</span> {docStatus.has_nuss ? <Tag color="success" icon={<CheckCircleOutlined />}>Carregat</Tag> : <Tag color="warning" icon={<ExclamationCircleOutlined />}>Pendent</Tag>}</Space>} 
                                size="small"
                                headStyle={{ background: docStatus.has_nuss ? '#f6ffed' : '#fffbe6' }}
                            >
                                <Space direction="vertical" style={{ width: '100%' }}>
                                    <Upload beforeUpload={(f)=>handleFileUpload('NUSS',f)} showUploadList={false}>
                                        <Button icon={<UploadOutlined />} loading={uploading==='NUSS'} block>Pujar / Actualitzar NUSS</Button>
                                    </Upload>
                                    <Button 
                                        type="primary"
                                        icon={<DownloadOutlined />} 
                                        onClick={()=>handleDownload('NUSS')} 
                                        disabled={!docStatus.has_nuss}
                                        style={{ backgroundColor: docStatus.has_nuss ? '#52c41a' : undefined, borderColor: docStatus.has_nuss ? '#52c41a' : undefined }}
                                        block
                                    >
                                        Baixar NUSS
                                    </Button>
                                </Space>
                            </Card>
                        </Col>
                    </Row>
                </Tabs.TabPane>
            </Tabs>
            <div style={{textAlign:'right', marginTop:24}}>
                <Button type="primary" htmlType="submit" size="large" icon={<CheckCircleOutlined />}>Guardar Canvis DUAL</Button>
            </div>
        </Form>
    );
};

export default DualProfileForm;
